import { Typography } from '@altibox/design-system-component-lib';
import React, { FC, PropsWithChildren } from 'react';

import { i18n } from 'app/i18n';

import { StyledChooseContainer, StyledSubTitle, StyledText } from './choose-container.styled';

interface ChooseContainerProps {
    title: string;
    subTitle: string;
}

const ChooseContainer: FC<PropsWithChildren<ChooseContainerProps>> = (props) => {
    const { title, subTitle, children } = props;

    return (
        <StyledChooseContainer>
            <Typography variant="headline3" component="h1">
                {title}
            </Typography>
            <StyledSubTitle variant="paragraph1" component="h2">
                {subTitle}
            </StyledSubTitle>
            <StyledText variant="paragraph3" component="p">
                {i18n.components.chooseContainer.choose}
            </StyledText>
            {children}
        </StyledChooseContainer>
    );
};

export { ChooseContainer };
